import { RouteRecordRaw } from 'vue-router';
import activities from './activities';
import home from './home';
import locations from './locations';
import map from './map';
import profile from './profile';
import store from '@/store';
import { ModalServices } from '@/services/ModalServices';
import { VillageConfigClient } from '@/services/Services';
import { StorageServices } from '@/services/StorageServices';
import assistenza from './assistenza';
import meteo from './meteo';
import escursioni from './escursioni';
import videoReview from './videoReview';
import gallery from './gallery';
import shop from './shop';

let nextUpdateOn = new Date().getTime() - 1000;

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village',
            name: 'village',
            component: () => import("./layout.vue"),
            meta: {
                bottomCutFixed: true,
            },
            children: [
                ...activities.routes(),
                ...escursioni.routes(),
                ...meteo.routes(),
                ...assistenza.routes(),
                ...home.routes(),
                ...videoReview.routes(),
                ...locations.routes(),
                ...map.routes(),
                ...shop.routes(),
                ...profile.routes(),
                ...gallery.routes()
            ],
            beforeEnter: (to, from, next) => {
                if(!store.state.villageConfig){
                    if(profile.routes().some(x => x.name == to.name)){
                        next();
                    } else {
                        next("/villages/villageList");
                    }
                } else {
                    if(nextUpdateOn < new Date().getTime()){
                        VillageConfigClient.getById(store.state.villageConfig.identifier)
                        .then(x => {
                            store.state.villageConfig = x;
                            StorageServices.setVillageConfig(x);
                        })
                        nextUpdateOn = new Date().getTime() + 5 * 60 * 1000;
                    }
                    next();
                }
            }
        },
    ];
};